import { useState } from 'react';

import ToolCard from '../../../common/element/Card';
import Select from '../../../common/element/Select';
import { reorderNcodesAPI } from '../../../redux/tool/toolAPI';
import SweetAlertService from '../../../common/SweetAlert/SweetAlert';

const INNER_DRIVE_OPTIONS = ['Certainty', 'Variety', 'Significance', 'Love/Connection', 'Growth', 'Contribution'].map(
  (d) => ({ value: d, label: d })
);

const ScoreTable = ({ rows, pad }) => (
  <div className="bg-white rounded-md shadow-sm overflow-hidden border border-[#c5c5c5] mx-auto" style={{ maxWidth: 420 }}>
    <table className="min-w-full text-left cstm-border">
      <thead>
        <tr className="bg-[#FFF6EE]">
          <th className="px-6 py-3 font-lato not-italic font-medium text-[16px] leading-[150%] text-[#000]">Inner Drive</th>
          <th className="px-6 py-3 font-lato not-italic font-medium text-[16px] leading-[150%] text-[#000]">Your Score</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, idx) => (
          <tr key={r.key} className={`border-t ${idx === rows.length - 1 ? 'rounded-b-md' : ''}`}>
            <td className="px-6 py-3 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">{r.key}</td>
            <td className="px-6 py-3 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">{pad(r.value)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ResultCard = ({ result, token, isInterviewCandidate }) => {
  const [showCongrats, setShowCongrats] = useState(true);
  const [coachTop1, setCoachTop1] = useState(null);
  const [coachTop2, setCoachTop2] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (!result) return null;

  const payload = result?.data || result;
  const scores = payload?.scores || {};

  const rows = Object.entries(scores).map(([key, value]) => ({ key, value: value || 0 }));
  const pad = (n) => String(n).padStart(2, '0');

  const sortedRows = [...rows].sort((a, b) => b.value - a.value);
  const top2Assessment = sortedRows.slice(0, 2);

  // Prefer link_token from submit response; fall back to URL token if absent
  const effectiveToken = payload?.link_token || token || null;

  const handleCoachSubmit = async () => {
    if (!coachTop1 || !coachTop2) {
      SweetAlertService.showToast({ icon: 'error', title: 'Please select both Final Top Inner Drives.' });
      return;
    }
    if (coachTop1.value === coachTop2.value) {
      SweetAlertService.showToast({ icon: 'error', title: 'Please select two different Inner Drives.' });
      return;
    }
    setSubmitting(true);
    try {
      await reorderNcodesAPI(
        {
          user_ordered_items: {
            top_assessment: top2Assessment.map((r) => r.key),
            top_after_coach: [coachTop1.value, coachTop2.value],
          },
        },
        effectiveToken
      );
      SweetAlertService.showCongratulations({
        message: 'You have successfully identified your Inner Drives Assessment.',
      });
    } catch (err) {
      SweetAlertService.showToast({ icon: 'error', title: err.response?.data?.message || err.message || 'Something went wrong.' });
    } finally {
      setSubmitting(false);
    }
  };

  // ── Interview candidate: congratulations view only, no coach section ──
  if (isInterviewCandidate) {
    return (
      <div className="w-full flex items-center justify-center">
        <div className="w-full">
          <ToolCard className="p-4 md:p-8 bg-white">
            <div className="text-center mb-6">
              <h1 className="font-lato not-italic font-bold text-[28px] md:text-[48px] leading-[150%] text-[#FF8E1C] mb-2">Congratulations!</h1>
              <p className="font-lato not-italic font-medium text-[16px] leading-[150%] text-black mt-2">
                You have successfully identified your Inner Drives Assessment. <br /> Your 6 Inner Drives Assessment Are
              </p>
            </div>
            <ScoreTable rows={rows} pad={pad} />
            <div className="mt-6 text-center mx-auto" style={{ maxWidth: 500 }}>
              <p className="mb-2 font-lato not-italic font-medium text-[16px] leading-[150%] text-black">The "Inner Drive" with highest score is your topmost "Inner Drive".</p>
              <p className="mb-2 font-lato not-italic font-medium text-[16px] leading-[150%] text-black">The "Inner Drive" with second highest score is your second topmost "Inner Drive".</p>
            </div>
            <div className="mt-8 text-center mx-auto" style={{ maxWidth: 500 }}>
              <p className="mb-4 font-lato not-italic font-medium text-[16px] leading-[150%] text-black">To better understand how your top 2 "Inner Drives " affect your life & how to use these for your benefit & growth, please contact your coach for a coaching session.</p>
            </div>
          </ToolCard>
        </div>
      </div>
    );
  }

  // ── Score page (shown first, and on Back) ──
  if (showCongrats) {
    return (
      <div className="w-full flex items-center justify-center">
        <div className="w-full">
          <ToolCard className="p-4 md:p-8 bg-white">
            <div className="text-center mb-6">
              <p className="font-lato not-italic font-medium text-[16px] leading-[150%] text-black mt-2">
                You have successfully identified your Inner Drives Assessment. <br /> Your 6 Inner Drives Assessment Are
              </p>
            </div>
            <ScoreTable rows={rows} pad={pad} />
            <div className="mt-6 text-center mx-auto" style={{ maxWidth: 500 }}>
              <p className="mb-2 font-lato not-italic font-medium text-[16px] leading-[150%] text-black">The "Inner Drive" with highest score is your topmost "Inner Drive".</p>
              <p className="mb-2 font-lato not-italic font-medium text-[16px] leading-[150%] text-black">The "Inner Drive" with second highest score is your second topmost "Inner Drive".</p>
            </div>
            <div className="mt-8 text-center mx-auto" style={{ maxWidth: 500 }}>
              <p className="mb-4 font-lato not-italic font-medium text-[16px] leading-[150%] text-black">To better understand how your top 2 "Inner Drives " affect your life & how to use these for your benefit & growth, please contact your coach for a coaching session.</p>
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={() => setShowCongrats(false)}
                className="px-[18px] py-4 w-[150px] h-14 rounded-[12px] font-lato not-italic font-bold text-[16px] leading-[150%] transition-all duration-200 bg-[#FF8E1C] hover:bg-[#e07d18] text-white shadow-[0px_2px_5px_#FFF4E5]"
              >
                Next
              </button>
            </div>
          </ToolCard>
        </div>
      </div>
    );
  }

  // ── Coach section ──
  return (
    <div className="w-full flex items-center justify-center">
      <div className="w-full">
        <ToolCard className="p-4 md:p-8 bg-white">
          {/* Top 2 As Per Assessment */}
          <div className="mb-8">
            <h2 className="font-lato not-italic font-bold text-[20px] leading-[150%] text-[#1D2939] mb-4 text-center">
              Your Top 2 Inner Drives – As Per Assessment:
            </h2>
            <div className="bg-white rounded-md shadow-sm overflow-hidden border border-[#c5c5c5] mx-auto" style={{ maxWidth: 420 }}>
              <table className="min-w-full text-left cstm-border">
                <thead>
                  <tr className="bg-[#FFF6EE]">
                    <th className="px-6 py-3 font-lato not-italic font-medium text-[16px] leading-[150%] text-[#000]">Rank</th>
                    <th className="px-6 py-3 font-lato not-italic font-medium text-[16px] leading-[150%] text-[#000]">Inner Drive</th>
                    <th className="px-6 py-3 font-lato not-italic font-medium text-[16px] leading-[150%] text-[#000]">Your Score</th>
                  </tr>
                </thead>
                <tbody>
                  {top2Assessment.map((row, idx) => (
                    <tr key={row.key} className="border-t">
                      <td className="px-6 py-3 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">{idx + 1}</td>
                      <td className="px-6 py-3 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">{row.key}</td>
                      <td className="px-6 py-3 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">{pad(row.value)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Top 2 After Discussion With Coach */}
          <div className="mb-8">
            <h2 className="font-lato not-italic font-bold text-[20px] leading-[150%] text-[#1D2939] mb-4 text-center">
              Your Final Top 2 Inner Drives – After Discussion With Coach:
            </h2>
            <div className="flex flex-col gap-4 mx-auto" style={{ maxWidth: 420 }}>
              <div className="flex flex-col gap-1">
                <label className="font-lato font-medium text-[16px] text-[#1D2939] text-start">Top Inner Drive (1st)</label>
                <Select
                className="text-start"
                  options={INNER_DRIVE_OPTIONS}
                  value={coachTop1}
                  onChange={setCoachTop1}
                  placeholder="Select Inner Drive"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-lato font-medium text-[16px] text-[#1D2939] text-start">Top Inner Drive (2nd)</label>
                <Select
                className="text-start"
                  options={INNER_DRIVE_OPTIONS}
                  value={coachTop2}
                  onChange={setCoachTop2}
                  placeholder="Select Inner Drive"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-4">
            <button
              onClick={() => setShowCongrats(true)}
              className="px-[18px] py-4 w-[150px] h-14 rounded-[12px] font-lato not-italic font-bold text-[16px] leading-[150%] transition-all duration-200 border border-[#FF8E1C] text-[#FF8E1C] bg-white hover:bg-[#FFF6EE]"
            >
              Back
            </button>
            <button
              onClick={handleCoachSubmit}
              disabled={submitting}
              className="px-[18px] py-4 w-[150px] h-14 rounded-[12px] font-lato not-italic font-bold text-[16px] leading-[150%] transition-all duration-200 bg-[#FF8E1C] hover:bg-[#e07d18] text-white shadow-[0px_2px_5px_#FFF4E5] disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </ToolCard>
      </div>
    </div>
  );
};

export default ResultCard;
